import i18n from "i18n";

export const useLocale = (locale: any): void => {
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale);
  }
  return;
};
